export default __webpack_public_path__ + "static/media/portfolio-mowaamah.6469ef0d.png";